<style scoped lang="scss">
.breads{
  overflow:auto;line-height: 48px;margin-bottom:  20px;
}
.desc{
  font-size: 16px;text-indent: 0;
}
.compose-type{
    background: #f6fafd;
    padding-bottom: 80px;
    margin-top: 100px;
}
@media screen and (max-width: 640px) {
  .compose-type {
    margin-top: 50px;
    padding-bottom: 30px;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-长单链DNA合成 -->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <!-- banner -->
    <gene-top-banner :smallTitle="smallTitle" :bigTitle="bigTitle"></gene-top-banner>
    <section v-if="!$route.meta.invisibles">
      <!-- 导航 -->
      <div class="breads container">
        <bread></bread>
      </div>
      <!-- 概述 -->
      <div class="container">
        <p class="desc mb20">近几年研究显示，利用 CRISPR 技术进行基因编辑时，长单链 DNA（ssDNA）是合适的同源修复的供体模板。与双链DNA （dsDNA） 作为供体模板相比，使用 ssDNA 可以显著提高编辑效率和特异性，并且降低脱靶效应和细胞毒性。</p>
        <p class="desc">擎科生物推出长单链DNA合成服务，助力下游研发与应用。</p>
      </div>
      <!-- 服务内容 -->
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
      </div>
      <!-- 交付结果 -->
      <div class="container">
        <en-title title="交付结果" enTitle="Deliverables"></en-title>
        <gene-deliverables :products="products" :reports="reports"></gene-deliverables>
      </div>
      <!-- 应用领域 -->
      <div class="container">
        <en-title title="应用领域" enTitle="Application"></en-title>
        <p class="desc mb20">长单链 DNA（ssDNA）被认为是一种元素材料，在许多生物反应中具有许多应用潜力和相关 DNA 纳米技术的广泛适用性。</p>
        <p class="desc mb20">长单链 DNA（ssDNA）可以被用于规则间隔的短回文重复序列（CRISPR）和 CRISPR 相关蛋白 9（CRISPR-Cas9）系统进行的基因组编辑实验，采用长单链 DNA（ssDNA）可以作为非常有效的供体，无论是插入还是基因替换均能够明显的提高编辑效率。</p>
        <p class="desc mb20">长单链 DNA（ssDNA）还被广泛应用于单链构想多态性、体外转录研究、核酸酶 S1 定位、探针制备和标记、差减杂交等实验范围。如，可以将 ssDNA 用作 DNA 纳米技术的支架，用于药物输送的载体，分子诊断，基于 DNA 的数据存储和各种纳米级应用。</p>
        <p class="desc">ssDNA 随机整合的风险较双链DNA（dsDNA） 大大降低，特别适合原代细胞、干细胞的基因编辑，基因改造动物模型的建立等。</p>
      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" downloadType="gene-ssDNA" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import GeneTopBanner from "./gene-components/geneTopBanner"
import EnTitle from '@/components/EnTitle'
import GeneAdvantages from './gene-components/geneAdvantages'
import GeneDetailTable from './gene-components/geneDetailTable'
import GeneDeliverables from './gene-components/geneDeliverables'
export default {
  components:{
    bread, 
    GeneTopBanner,
    EnTitle,
    GeneAdvantages,
    GeneDetailTable,
    GeneDeliverables,
  },
  data () {
    return {
      smallTitle:'全基因组合成',
      bigTitle:'长单链DNA合成',
      tableColumn:[
        {
          label:'基因长度 (nt)',
          prop:'geneLength',
        },
        {
          label:'生产周期（工作日）',
          prop:'productionCycle',
        },
      ],
      tableData:[
        {
          geneLength:'101 - 240',
          productionCycle:'10',
        },
        {
          geneLength:'241 - 1000',
          productionCycle:'15',
        },
        {
          geneLength:'1001 - 3000',
          productionCycle:'22',
        },
        {
          geneLength:'3001 - 4000',
          productionCycle:'28',
        },
        {
          geneLength:'4001 - 5000',
          productionCycle:'32',
        },
        {
          geneLength:'> 5000',
          productionCycle:'需要评估',
        },
      ],
      products:'产物干粉',
      reports:'测序图谱 (.abl 文件 )\n目标序列 (.seq 文件 )\nCOA 文件'
    }
  },
  methods: {
    tableSpanMethod(){}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/ssDNA_page.vue